module.exports = __webpack_public_path__ + "static/media/msnsetup_1.e3f2542c.ico";